<template>
  <div>
    <masonry :cols="cols" :gutter="{ default: '15px' }"
      class="masonry">
      <div class="card card__payments">
        <h1 class="card__title">
          {{ $t('messages.my_kickstarters') }}
        </h1>
        <div class="card__description card__split">
          <div class="p-20 pt-0">
            <p class="smallTitle">{{ $t('messages.show_projects_title') }}:</p>
            <b-form-checkbox id="toPay" v-model="params.toPay" name="toPay" class="filterCheckbox">
              {{ $t('messages.show_to_pay_projects_only') }}
            </b-form-checkbox>
            <b-form-checkbox id="toDeliver" v-model="params.toDeliver" name="toDeliver" @change="handleFilterDeliverChange" class="filterCheckbox">
              {{ $t('messages.show_to_deliver_projects_only') }}
            </b-form-checkbox>
            <b-form-checkbox id="delivered" v-model="params.delivered" name="delivered" @change="handleFilterDeliverChange" class="filterCheckbox">
              {{ $t('messages.show_delivered_projects_only') }}
            </b-form-checkbox>
            <b-form-checkbox id="userShipped" v-model="params.userShipped" name="userShipped" @change="handleFilterDeliverChange" class="filterCheckbox">
              {{ $t('messages.show_user_shipped_projects_only') }}
            </b-form-checkbox>
            <b-form-checkbox id="userDelivered" v-model="params.userDelivered" name="userDelivered" @change="handleFilterDeliverChange" class="filterCheckbox">
              {{ $t('messages.show_user_delivered_projects_only') }}
            </b-form-checkbox>
            <b-form-checkbox id="organisator" v-if="organisators.length > 0" v-model="organisator" name="organisator"
                             class="filterCheckbox filterOrganisator">
              <div class="d-flex">
                <div class="flex-grow-1">{{ $t('messages.show_organisator_projects_only') }}</div>
                <div class="flex-grow-1">
                  <b-form-select v-model="params.organisator" :disabled="!loggedIn" class="organisatorSelect">
                    <option :value="false"></option>
                    <option v-for="organisator in organisators" :key="'o-' + organisator.id" :value="organisator.id">{{ organisator.full_name }}</option>
                  </b-form-select>
                </div>
              </div>
            </b-form-checkbox>
          </div>
          <div class="d-flex flex-column">
            <div class="d-flex">
              <div class="w-50 text-center p-10">
                <div class="font-weight-bold">{{ $t('messages.amount_total') }}:</div>
                <div>€ {{ amount | round(2) }}</div>
              </div>
              <div class="w-50 text-center p-10">
                <div class="font-weight-bold">{{ $t('messages.paid_total') }}:</div>
                <div>€ {{ paid | round(2) }}</div>
              </div>
            </div>
            <div class="w-100 text-center p-10" :class="getPaymentBackground(difference)">
              <div>{{ $t('messages.difference_total') }}:</div>
              <div>€ {{ difference | round(2) }}</div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <project-tile v-if="projects" v-for="project in projects" :project="project"
                    :show-payments="true" :key="'p' + project.id"></project-tile>
    </masonry>
    <div class="load-more-wrapper">
      <b-button v-if="hasMore" variant="primary" class="w-100" @click="loadMore">
        {{ $t('messages.load_more') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import ProjectTile from '../../components/project/ProjectTile'

import { defaultMixin } from '../../mixin/default'
import { navigationMixin } from '../../mixin/navigation'

import { projectService } from '../../services/project.service'

Vue.use(VueMasonry)

export default {
  name: 'projects',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.my_kickstarters') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.my_kickstarters'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  mixins: [ defaultMixin, navigationMixin ],
  components: { ProjectTile },
  data: function () {
    return {
      cols: {
        default: 6,
        1600: 5,
        1300: 4,
        1000: 2,
        700: 1
      },
      rows: 4,
      params: {
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        toPay: this.$route.query.toPay ? JSON.parse(this.$route.query.toPay) : false,
        toDeliver: this.$route.query.toDeliver ? JSON.parse(this.$route.query.toDeliver) : false,
        delivered: this.$route.query.delivered ? JSON.parse(this.$route.query.delivered) : false,
        userShipped: this.$route.query.userShipped ? JSON.parse(this.$route.query.userShipped) : false,
        userDelivered: this.$route.query.userDelivered ? JSON.parse(this.$route.query.userDelivered) : false,
        organisator: this.$route.query.organisator ? parseInt(this.$route.query.organisator) : false
      },
      loaded: false,
      hasMore: false,
      projects: [],
      initialized: false,
      organisators: [],
      amount: 0,
      paid: 0,
      difference: 0,
      organisator: false,
      timeout: null
    }
  },
  methods: {
    handleFilterDeliverChange: function () {
      this.params.toDeliver = false
      this.params.delivered = false
      this.params.userShipped = false
      this.params.userDelivered = false

      this.timeFetchProjects()
    },
    timeFetchProjects: function () {
      var self = this
      if (self.timeout) {
        clearTimeout(self.timeout)
      }
      this.timeout = setTimeout(function () {
        self.resetAndLoad()
      }, 100)
    },
    fetchProjects: function () {
      let size = null
      let screenWidth = window.innerWidth
      for (let key in this.cols) {
        if (size === null) {
          if (key !== 'default' && screenWidth <= key) {
            size = this.cols[key]
          } else if (key === 'default') {
            size = this.cols[key]
          }
        }
      }
      size = (size * this.rows) - (this.params.page === 1 ? 1 : 0)

      let loader = this.$loading.show()
      let totalComplete = 0
      let totalMaxComplete = this.loaded ? 1 : 3

      let store = this.$store

      let filter = _.merge(JSON.parse(JSON.stringify(this.params)), {
        page: this.initialized ? this.params.page : 1,
        size: this.initialized ? size : (this.params.page * size)
      })

      projectService.fetchForUser(store.state.userId, filter)
        .then((projects) => {
          if (this.params.page === 1) {
            this.projects = projects
          } else {
            this.projects = this.projects.concat(projects)
          }
          this.hasMore = projects.length === (this.initialized ? size : (this.params.page * size))
          if (!this.initialized) {
            this.$store.commit('moveToScrollPosition')
          }
          this.initialized = true
          totalComplete++
          if (totalComplete === totalMaxComplete) {
            loader.hide()
          }
        }, () => {
          this.initialized = true
          store.commit('error', 'errors.user_fetch_different')
          totalComplete++
          if (totalComplete === totalMaxComplete) {
            loader.hide()
          }
        })

      if (!this.loaded) {
        projectService.fetchOrganisatorsForUser(store.state.userId)
          .then((organisators) => {
            this.organisators = organisators
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          }, () => {
            store.commit('error', 'errors.user_fetch_different')
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          })

        projectService.fetchStatsForUser(store.state.userId)
          .then((stats) => {
            this.amount = stats.amount
            this.paid = stats.paid
            this.difference = stats.difference
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          }, () => {
            store.commit('error', 'errors.user_fetch_different')
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          })
      }

      this.loaded = true
    },
    loadMore: function () {
      this.params.page += 1
      this.load()
    },
    resetAndLoad: function () {
      this.params.page = 1
      this.load()
    },
    load: function () {
      let params = this.params
      let query = this.generateQueryParams(params)
      this.pushUrlState(query)
      this.fetchProjects()
    },
    getPaymentBackground: function (amount) {
      if (amount >= 0) {
        return 'bg-success text-white font-weight-bold'
      } else {
        return 'bg-danger text-white font-weight-bold'
      }
    }
  },
  watch: {
    organisator: function () {
      if (!this.organisator) {
        this.params.organisator = false
      }
      this.timeFetchProjects()
    },
    'params.toPay': function () {
      this.timeFetchProjects()
    },
    'params.organisator': function () {
      if (this.params.organisator !== false) {
        if (this.organisator === true) {
          this.timeFetchProjects()
        } else {
          this.organisator = true
        }
      } else {
        if (this.organisator === false) {
          this.timeFetchProjects()
        } else {
          this.organisator = false
        }
      }
    }
  },
  created: function () {
    this.fetchProjects()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .masonry {
    padding: 10px;
  }

  .load-more-wrapper {
    margin-top: -20px;
    padding: 0px 10px 10px;
  }

  .card__title {
    height: auto;
  }

  .card__description {
    height: 100%;
    padding: 0px;
  }

  .card__split {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media screen and (min-width: 701px) {
    .card__payments {
      height: 500px;
    }
  }

  .smallTitle {
    font-weight: bold;
    margin-bottom: 5px;
  }

  .filterCheckbox {
    margin: 3px 0px;
  }

  .organisatorSelect {
    margin-left: 10px;
  }

  .clear {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/Projects.vue